/* Zeus scroll-reveal -- Summer 2026
   Adds .is-visible to elements with .zeus-reveal once they enter viewport.
   PERF-CLS-REVEAL: force-visible anything already in the first viewport immediately
   (no opacity-0 holes above the fold). */
(function () {
  function forceVisible(el) {
    el.classList.add("is-visible");
    el.style.opacity = "1";
    el.style.visibility = "visible";
    el.style.transform = "none";
  }

  function revealHashTarget() {
    if (!window.location.hash) return;
    var target;
    try {
      target = document.querySelector(window.location.hash);
    } catch (e) {
      return;
    }
    if (!target) return;
    target.querySelectorAll(".zeus-reveal, [reveal-on-scroll='true'], [reveal-js], reveal-items").forEach(forceVisible);
    var section = target.closest(".shopify-section") || target;
    section
      .querySelectorAll(".zeus-reveal, [reveal-on-scroll='true'], [reveal-js], reveal-items")
      .forEach(forceVisible);
  }

  function revealInViewport() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      document
        .querySelectorAll(".zeus-reveal, [reveal-on-scroll='true'], [reveal-js], reveal-items")
        .forEach(forceVisible);
      return;
    }

    var vh = window.innerHeight || document.documentElement.clientHeight || 0;
    document
      .querySelectorAll(".zeus-reveal, [reveal-on-scroll='true'], [reveal-js], reveal-items")
      .forEach(function (el) {
        var rect = el.getBoundingClientRect();
        // Already intersecting first viewport (including partially) → show now
        if (rect.top < vh && rect.bottom > 0) {
          forceVisible(el);
        }
      });
  }

  /* Defensive watchdog for the theme's native <reveal-items> custom element.
     RevealItems (theme.js) only calls its internal reveal callback when
     BOTH "prefers-reduced-motion: no-preference" matches AND
     settings.stagger_products_apparition is enabled -- if that gate is
     skipped/races (e.g. window.themeVariables not ready yet, or the
     element is already in the viewport at parse time so no further
     scroll/intersection event ever fires) the element is left stuck at
     `opacity: 0` forever, even though its children are fully visible and
     laid out. This produces a blank void where the product grid should be
     (bug #10, STOP-SHIP). We do not touch theme.js/RevealItems itself
     (vendor code) -- instead we force opacity:1 on any <reveal-items> that
     hasn't self-revealed within a short grace period. */
  function watchdogRevealItems() {
    var stuck = document.querySelectorAll("reveal-items");
    if (!stuck.length) return;
    setTimeout(function () {
      stuck.forEach(function (el) {
        var opacity = window.getComputedStyle(el).opacity;
        if (parseFloat(opacity) < 1) {
          forceVisible(el);
        }
      });
    }, 800);
  }

  if (typeof IntersectionObserver === "undefined") {
    document.querySelectorAll(".zeus-reveal").forEach(forceVisible);
    revealInViewport();
    revealHashTarget();
    watchdogRevealItems();
    return;
  }

  var io = new IntersectionObserver(
    function (entries, obs) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add("is-visible");
          obs.unobserve(e.target);
        }
      });
    },
    { threshold: [0, 0.15, 0.3], rootMargin: "0px 0px -8% 0px" },
  );

  document.querySelectorAll(".zeus-reveal").forEach(function (el) {
    io.observe(el);
  });

  function boot() {
    // Sync first: clear ATf opacity holes before paint settles
    revealInViewport();
    revealHashTarget();
    // Second pass after layout (fonts / sticky header)
    requestAnimationFrame(function () {
      revealInViewport();
    });
    watchdogRevealItems();
  }

  window.addEventListener("hashchange", revealHashTarget, { passive: true });
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
